/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Card from 'src/common/refactoredComponents/card/Card';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    Header,
    BasicOptionContainer,
    ContentBody,
    Options,
    AddRecipientContainer,
    Add,
    InputCont,
    CheckBoxContainer,
    HeaderContainer,
    DetailBody,
    ButtonContainer,
    FooterContent,
    StyledHorizontalRow,
    InputWithRecipientContainer,
    ErrorContainer,
    UploadedFilesContainer,
    FileLinkDiv,
    FileLinkContainer,
    FileImage,
} from './SendUsageReport.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import {
    setSendReportModalState,
    showHideSummaryModal,
    showHideSearchModalAction,
    showHideViewReportAction,
    showHideSendReportAction,
    setOrderStatus,
    setDescrepencyImageViewState,
} from 'src/pages/orders/redux/actions';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import Input from 'src/common/components/form/input/Input';
import Close from 'src/assets/images/ModalClose.svg';
import {
    sendReport,
    viewReport,
    viewPdfReport,
    resetSendUsageReportAction,
} from 'src/pages/orders/redux/actions';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import {
    CloseIconContainer,
    CloseIcon,
} from 'src/pages/orders/components/orderDetails/orderDetailHeader/OrderDetailHeader.styled';

import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';

import ReportHistory from '../reportHistory/ReportHistory';
import ReportsFooter from '../reportsFooter/ReportsFooter';
import {
    getFormattedPhoneNumber,
    getHyphenFormattedNumber,
    resumeScrolling,
    logErrorToConsole,
} from 'src/utils/util';
import sendUsageReportOptions from './sendUsageReportOptions';
import FileLink from 'src/assets/images/FileLink.svg';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';

import { getPoImagePreview } from 'src/pages/reportUsage/redux/action/actionCreators';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { useTranslation } from 'react-i18next';
import { XX_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { validateEmail as validateEmailCommon } from 'src/pages/reportUsage/utils/reportUsageUtil';

const SendUsageReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const myCaseRef = useSelector(
        (state) => state.orderSummaryReducer.myCaseRef
    );

    const { loading, statusCode, isSendReportReset } = useSelector(
        (state) => state.sendReportReducer
    );

    const {
        sendReportModal,
        isUsageReportOrderListPage,
        isUsageReportSearchListPage,
    } = useSelector((state) => state.orderSummaryReducer);

    const { viewReportData, viewReportHistory } = useSelector(
        (state) => state.viewReportReducer
    );

    //const [viewReportOpen, setViewReportOpen] = useState(false);

    const [reportHistory, setReportHistory] = useState([]);

    const [userEmailIdSelected, setUserEmailIdSelected] = useState(false);

    const [priceChecked, setPriceChecked] = useState('');

    const [reportTypeChecked, setReportTypeChecked] = useState('combined');

    const [sendTypeChecked, setSendTypeChecked] = useState('isEmail');

    const [emailInputBoxes, setEmailInputBoxes] = useState([
        { value: '', errorMessage: '' },
    ]);
    const [faxInputBoxes, setFaxInputBoxes] = useState([
        { value: '', errorMessage: '' },
    ]);
    const [showReportOption, setShowReportOption] = useState(false);

    const [isExpanded, setIsExpanded] = useState({
        isHistoryExpanded: false,
        isRecipients: false,
    });

    const [, setKeyboardPaddingBottom] = useState('');

    const [discrepencyFiles, setDiscrepencyFiles] = useState([]);

    const { poImagePreviewDetails, poImagePreviewLoader } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const discrepancyUsageDetails = useSelector(
        (state) => state.reportUsageRootReducer.discrepancyUsageDetails
    );
    const discrepencyUpdatedDetails = useSelector(
        (state) => state.reportUsageRootReducer.discrepencyUpdatedDetails
    );
    const discrepancyAttachment = useSelector(
        (state) => state.reportUsageRootReducer.discrepancyAttachment
    );
    const uploadedFilesNames =
        discrepancyUsageDetails?.usageSEDiscrepancy?.discrepancyDto?.uploadedFileNames?.split(
            ','
        );
    const discrepancyEntries =
        discrepancyUsageDetails?.discrepancyExists ||
        discrepencyUpdatedDetails?.discrepancyExists;

    const sendReportInitalCall = () => {
        let paramsArr = createReqObj();
        const [pricing, reportOption] = paramsArr;
        dispatch(viewReport(myCaseRef, pricing, reportOption, sendTypeChecked));
    };

    useDynatracePageName(pageNames.ordersUsageReport);

    useEffectWithErrorLogging(() => {
        if (discrepancyAttachment?.length > 0) {
            setDiscrepencyFiles(discrepancyAttachment);
        } else if (uploadedFilesNames?.length > 0) {
            setDiscrepencyFiles(uploadedFilesNames);
        } else {
            setDiscrepencyFiles([]);
        }
    }, [discrepancyAttachment?.length, uploadedFilesNames?.length]);

    useEffectWithErrorLogging(() => {
        if (sendReportModal) {
            sendReportInitalCall();
        }
        return () => resumeScrolling();
    }, [sendReportModal, priceChecked, sendTypeChecked]);

    useEffectWithErrorLogging(() => {
        if (viewReportHistory && viewReportHistory.length > 0) {
            const reportHistory =
                priceChecked ===
                sendUsageReportOptions().usagePricingRadio[0].value
                    ? viewReportHistory.filter((x) => x.pricing)
                    : priceChecked ===
                      sendUsageReportOptions().usagePricingRadio[1].value
                    ? viewReportHistory.filter(
                          (x) => !x.pricing && x?.type !== 'DISCREPANCY'
                      )
                    : priceChecked ===
                      sendUsageReportOptions().discrepancyOption[0].value
                    ? viewReportHistory.filter((x) => x?.type === 'DISCREPANCY')
                    : viewReportHistory;

            setReportHistory(reportHistory);
        } else {
            setReportHistory([]);
        }
    }, [viewReportHistory]);

    useEffectWithErrorLogging(() => {
        if (
            viewReportData?.usageReportDTO &&
            viewReportData?.usageReportDTO?.length &&
            viewReportData?.usageReportDTO.length > 0
        ) {
            const usageTissue =
                viewReportData?.usageReportDTO?.filter(
                    (x) => x.group === 'S030'
                )?.length > 0
                    ? true
                    : false;

            const usageNonTissue =
                viewReportData?.usageReportDTO?.filter(
                    (x) => x.group === 'S002'
                )?.length > 0
                    ? true
                    : false;
            usageTissue &&
            usageNonTissue &&
            priceChecked &&
            priceChecked !== sendUsageReportOptions().discrepancyOption[0].value
                ? setShowReportOption(true)
                : setShowReportOption(false);
        }
    }, [viewReportData, priceChecked]);

    useEffectWithErrorLogging(() => {
        if (isSendReportReset) {
            //setViewReportOpen(false);
            sendReportInitalCall();
            dispatch(
                showHideViewReportAction({
                    viewReportOpen: false,
                    viewReportBackNavigate: '',
                })
            );
            setIsExpanded({
                ...isExpanded,
                isRecipients: false,
            });
            setUserEmailIdSelected(false);
            setPriceChecked('');
            setReportTypeChecked('combined');
            setSendTypeChecked(sendTypeChecked);
            setEmailInputBoxes([{ value: '', errorMessage: '' }]);
            setFaxInputBoxes([{ value: '', errorMessage: '' }]);
            setShowReportOption(false);
        }
    }, [isSendReportReset]);

    const onAddEmailRecipientHandler = () => {
        let previous = [...emailInputBoxes, { value: '', errorMessage: '' }];
        setEmailInputBoxes(previous);
    };

    const onChangeEmail = (index, value) => {
        const emailInputBox = [...emailInputBoxes];
        if (value === '') {
            emailInputBox[index].errorMessage = '';
        }
        emailInputBox[index].value = value;
        setEmailInputBoxes(emailInputBox);
    };

    const onAddFaxRecipientHandler = () => {
        let previous = [...faxInputBoxes, { value: '', errorMessage: '' }];
        setFaxInputBoxes(previous);
    };

    const onChangeFax = (index, value) => {
        const faxInputBox = [...faxInputBoxes];
        const prevValue = faxInputBox[index].value;
        faxInputBox[index].value =
            value === '' ? '' : faxNumberValidate(value, prevValue);
        setFaxInputBoxes(faxInputBox);
    };

    const faxNumberValidate = (faxValue, prevValue) => {
        let isnum = null;
        let value = faxValue;
        const re = /^[0-9\b]+$/;

        const numbersOnlyString = value.replace(/\D/g, '');
        isnum =
            numbersOnlyString.length > 0
                ? /^\d+$/.test(numbersOnlyString)
                : null;
        if (re.test(numbersOnlyString)) {
            if (isnum && numbersOnlyString.length < 11) {
                return numbersOnlyString.substring(0, 10);
            } else if (isnum) {
                return prevValue;
            }
        } else {
            return prevValue;
        }
    };

    const onPriceTypeChangeHandler = (name) => {
        setPriceChecked(name);
    };

    const onReportTypeChangeHandler = (name) => {
        setReportTypeChecked(name);
    };

    const onSendTypeChangeHandler = (name) => {
        if (name === 'isEmail') {
            setFaxInputBoxes([{ value: '', errorMessage: '' }]);
        } else {
            setEmailInputBoxes([{ value: '', errorMessage: '' }]);
        }
        setSendTypeChecked(name);
    };
    const validateEmail = (email) => {
        const result = validateEmailCommon(email);        
        return result;
    };

    const onSendUsageReport = () => {
        if (loading) return;
        if (sendTypeChecked === 'isEmail') {
            const checkNonEmptyEmailLists =
                emailInputBoxes.length > 1
                    ? emailInputBoxes.filter((x) => x.value !== '')?.length > 0
                        ? true
                        : false
                    : false;

            emailInputBoxes && emailInputBoxes?.length
                ? emailInputBoxes.length > 1 && checkNonEmptyEmailLists
                    ? emailInputBoxes.map((emails) => {
                          if (emails && emails.value) {
                              if (!validateEmail(emails.value)) {
                                  emails.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.reqinvoice'
                                  );
                              } else {
                                  emails.errorMessage = '';
                              }
                          } else {
                              emails.errorMessage = '';
                          }

                          return { ...emails };
                      })
                    : emailInputBoxes.map((emails, index) => {
                          if (
                              index === 0 &&
                              !(userEmailIdSelected && emails.value === '')
                          ) {
                              if (!validateEmail(emails.value)) {
                                  emails.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.reqinvoice'
                                  );
                              } else {
                                  emails.errorMessage = '';
                              }
                          }

                          return { ...emails };
                      })
                : null;

            setEmailInputBoxes([...emailInputBoxes]);
            const checkValid =
                emailInputBoxes.filter((x) => x.errorMessage !== '').length > 0;
            if (!checkValid) {
                dispatchMailFax();
            }
        }

        if (sendTypeChecked === 'isFax') {
            const checkNonEmptyFaxLists =
                faxInputBoxes.length > 1
                    ? faxInputBoxes.filter((x) => x.value !== '')?.length > 0
                        ? true
                        : false
                    : false;

            faxInputBoxes && faxInputBoxes?.length
                ? faxInputBoxes.length > 1 && checkNonEmptyFaxLists
                    ? faxInputBoxes.map((fax) => {
                          if (fax && fax.value) {
                              if (fax?.value?.length < 10) {
                                  fax.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.invalidfax'
                                  );
                              } else {
                                  fax.errorMessage = '';
                              }
                          } else {
                              fax.errorMessage = '';
                          }

                          return { ...fax };
                      })
                    : faxInputBoxes.map((fax, index) => {
                          if (index === 0) {
                              if (fax?.value?.length < 10 || fax.value === '') {
                                  fax.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.invalidfax'
                                  );
                              } else {
                                  fax.errorMessage = '';
                              }
                          }
                          return { ...fax };
                      })
                : null;

            setFaxInputBoxes([...faxInputBoxes]);
            const checkValid =
                faxInputBoxes.filter((x) => x.errorMessage !== '').length > 0;
            if (
                !checkValid ||
                (faxInputBoxes[0]?.value !== '' &&
                    faxInputBoxes[0]?.value.length >= 10)
            ) {
                dispatchMailFax();
            }
        }
    };

    const getEmailIdsTobeSent = (emailInputBoxes, userEmailId) => {
        const emailsFromEmailInputBoxes = emailInputBoxes
            ?.filter((x) => x.value !== '')
            .map((email) => email.value)
            .join(',');
        if (emailsFromEmailInputBoxes.length > 1) {
            return `${emailsFromEmailInputBoxes},${userEmailId}`;
        } else {
            return userEmailId;
        }
    };

    const dispatchMailFax = () => {
        const isFaxWithDefaultEmail =
            userEmailIdSelected && sendTypeChecked === 'isFax';

        dispatch(
            sendReport({
                report_type:
                    priceChecked === 'USAGE_DISCREPANCY_REPORT'
                        ? 'USAGE_DISCREPANCY_REPORT'
                        : 'USAGE_REPORT',
                reportScope: reportTypeChecked,
                emailIds: isFaxWithDefaultEmail
                    ? userDetails.emailId
                    : userEmailIdSelected
                    ? getEmailIdsTobeSent(emailInputBoxes, userDetails.emailId)
                    : emailInputBoxes
                          ?.filter((x) => x.value !== '')
                          .map((email) => email.value)
                          .join(','),
                faxNumbers: faxInputBoxes
                    ?.filter((f) => f.value !== '')
                    .map((fax) => getHyphenFormattedNumber(fax.value))
                    .join(','),
                pricingRequired: priceChecked === 'withPrice' ? true : false,
                myCaseRef: myCaseRef,
            })
        );
    };

    const viewReportHandler = () => {
        let paramsArr = createReqObj();
        const [pricing, reportOption] = paramsArr;
        dispatch(viewPdfReport(myCaseRef, pricing, reportOption));
        dispatch(
            showHideViewReportAction({
                viewReportOpen: true,
                viewReportBackNavigate: 'Reports',
            })
        );
        dispatch(showHideSendReportAction({ sendReportModal: false }));
    };

    const createReqObj = () => {
        let pricing,
            reportOption = '';
        // concatStrToReportOption = '';
        //temparary added for discrepancy report
        if (priceChecked === 'USAGE_DISCREPANCY_REPORT') {
            pricing = false;
            reportOption = 'USAGE_DISCREPANCY_REPORT';
        } else {
            if (
                priceChecked === 'withPrice' ||
                priceChecked === 'withoutPrice'
            ) {
                pricing = priceChecked === 'withPrice' ? true : false;
                // concatStrToReportOption = priceChecked;
                if (reportTypeChecked === 'nonTissue') {
                    reportOption = 'nonTissue';
                } else if (reportTypeChecked === 'tissue') {
                    reportOption = 'tissue';
                } else if (reportTypeChecked === 'separate') {
                    reportOption = 'separate';
                } else if (reportTypeChecked === 'combined') {
                    reportOption = 'combined';
                }
            } else {
                pricing = '';
                reportOption = 'combined';
            }
        }
        return [pricing, reportOption];
    };

    const handleKeyboardOpen = (paddingHeight, container) => {
        setKeyboardPaddingBottom(paddingHeight);
        const element = document.getElementsByClassName(container);
        element.onscroll = function () {
            element.scrollTo(0, element[0].scrollHeight);
        };
    };
    const handleKeyboardClose = (paddingHeight) => {
        setKeyboardPaddingBottom(paddingHeight);
    };

    const openReport = (fileName) => {
        if (fileName) {
            const object = {
                fileName,
            };
            dispatch(getPoImagePreview(object));
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            poImagePreviewDetails != null ||
            (poImagePreviewDetails != undefined && !poImagePreviewLoader)
        ) {
            dispatch(setDescrepencyImageViewState(true));
            dispatch(showHideSendReportAction({ sendReportModal: false }));
        }
    }, [poImagePreviewDetails, poImagePreviewLoader]);

    return (
        <>
            {sendReportModal && (
                <ModalDialog
                    modalHeight={'calc(100vh - 110px)'}
                    modalWidth={'70%'}
                    left={'0%'}
                    right={'0%'}
                    top={'7%'}
                    bottom={'5%'}
                    height={'100%'}
                    marginTop={'7rem'}
                    zIndex={'2000'}
                    padding={'0px'}
                    handleClose={() => {
                        try {
                        if (isUsageReportSearchListPage) {
                            dispatch(
                                showHideSearchModalAction({
                                    showSearchModal: true,
                                })
                            );
                        }
                        dispatch(
                            setSendReportModalState({
                                showModal: false,
                                myCaseRefId: '',
                                isUsageReportOrderListPage: false,
                                isUsageReportSearchListPage: false,
                            })
                        );
                        dispatch(
                            showHideSendReportAction({
                                sendReportModal: false,
                            })
                        );
                        dispatch(
                            setOrderStatus({ orderStatus: '' })
                        );
                        dispatch(resetSendUsageReportAction());
                        } catch (error) {
                             logErrorToConsole(error);
                        }
                    }}
                >
                    <ContentBody>
                        <HeaderContainer>
                            <Header fontSize="18px">
                                {t(
                                    'orders.reportsAndInvoice.sendUsageReport.reports'
                                )}
                            </Header>

                            {/* <CloseIconContainer>
                                <CloseIcon
                                    mobilePath={Close}
                                    show={true}
                                    onClick={() => {
                                        if (isUsageReportSearchListPage) {
                                            dispatch(
                                                showHideSearchModalAction({
                                                    showSearchModal: true,
                                                })
                                            );
                                        }
                                        dispatch(
                                            setSendReportModalState({
                                                showModal: false,
                                                myCaseRefId: '',
                                                isUsageReportOrderListPage: false,
                                                isUsageReportSearchListPage: false,
                                            })
                                        );
                                        dispatch(
                                            showHideSendReportAction({
                                                sendReportModal: false,
                                            })
                                        );
                                        dispatch(
                                            setOrderStatus({ orderStatus: '' })
                                        );
                                        dispatch(resetSendUsageReportAction());
                                    }}
                                />
                            </CloseIconContainer> */}
                        </HeaderContainer>
                        {!isUsageReportOrderListPage &&
                        !isUsageReportSearchListPage ? (
                            <BackButtonContainer
                             id="orders-sendusagereport-back-button-container"
                                onClick={() => {
                                    try {
                                    dispatch(
                                        setSendReportModalState({
                                            showModal: false,
                                            myCaseRefId: myCaseRef,
                                            isUsageReportOrderListPage: false,
                                            isUsageReportSearchListPage: false,
                                        })
                                    );
                                    dispatch(
                                        showHideSendReportAction({
                                            sendReportModal: false,
                                        })
                                    );

                                    dispatch(
                                        showHideSummaryModal({
                                            orderSummaryModal: true,
                                        })
                                    );
                                    dispatch(resetSendUsageReportAction());
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                            >
                                <BackButtonIcon src={BackIcon} />
                                <BackText>{`${t(
                                    'common.backToText'
                                )} ${myCaseRef}`}</BackText>
                            </BackButtonContainer>
                        ) : null}

                        <DetailBody
                            scrollBarWidth={'8px'}
                            scrollBarBackgroundColor={'#888'}
                            scrollBarBorderRadius={'10px'}
                            mediumDeviceScrollBarDisplay={'block'}
                        >
                            <div style={{ height: '100%' }}>
                                <Card
                                    padding="15px 22px"
                                    margin="10px 0 10px 0"
                                    height="auto"
                                >
                                    <Header
                                        showAstrisk={true}
                                        letterSpacing="-0.12px"
                                    >
                                        {t(
                                            'orders.reportsAndInvoice.sendUsageReport.reportFormat'
                                        )}
                                    </Header>
                                    <BasicOptionContainer>
                                        {sendUsageReportOptions() &&
                                            sendUsageReportOptions().usagePricingRadio.map(
                                                (rad) => {
                                                    return (
                                                        <>
                                                            <RadioButton
                                                                noWrap = {'nowrap'}
                                                                key={rad.label}
                                                                id={'usage-pricing'}
                                                                label={
                                                                    rad.label
                                                                }
                                                                fontFamilyStyle={
                                                                    'AvenirNextWorld Regular'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                isChecked={
                                                                    priceChecked ===
                                                                    rad.value
                                                                }
                                                                handleChange={() =>
                                                                    onPriceTypeChangeHandler(
                                                                        rad.value
                                                                    )
                                                                }
                                                            />
                                                        </>
                                                    );
                                                }
                                            )}
                                    </BasicOptionContainer>
                                    {discrepancyEntries && (
                                        <>
                                            <StyledHorizontalRow />
                                            <BasicOptionContainer>
                                                {sendUsageReportOptions() &&
                                                    sendUsageReportOptions().discrepancyOption.map(
                                                        (rad) => {
                                                            return (
                                                                <>
                                                                    <RadioButton
                                                                        noWrap = {'nowrap'}
                                                                        key={
                                                                            rad.label
                                                                        }
                                                                        id={'discrepencyOptions'}
                                                                        label={
                                                                            rad.label
                                                                        }
                                                                        fontFamilyStyle={
                                                                            'AvenirNextWorld Regular'
                                                                        }
                                                                        color={
                                                                            '#202124'
                                                                        }
                                                                        isChecked={
                                                                            priceChecked ===
                                                                            rad.value
                                                                        }
                                                                        handleChange={() =>
                                                                            onPriceTypeChangeHandler(
                                                                                rad.value
                                                                            )
                                                                        }
                                                                    />
                                                                </>
                                                            );
                                                        }
                                                    )}
                                            </BasicOptionContainer>
                                        </>
                                    )}
                                </Card>
                                {discrepencyFiles?.length > 0 && (
                                    <Card
                                        padding="15px 22px"
                                        margin="10px 0 10px 0"
                                        height="auto"
                                    >
                                        <Header letterSpacing="-0.12px">
                                            {t(
                                                'orders.reportsAndInvoice.sendUsageReport.attachedDocuments'
                                            )}
                                        </Header>
                                        <UploadedFilesContainer>
                                            {discrepencyFiles?.map((file) => (
                                                <>
                                                    <FileLinkContainer
                                                        key={file}
                                                    >
                                                        <div>
                                                            <FileImage
                                                             id={`orders-sendusagereport-file-image-${file.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`}
                                                                imgPath={
                                                                    FileLink
                                                                }
                                                                onClick={() =>
                                                                    openReport(
                                                                        file
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <FileLinkDiv
                                                        id={`orders-sendusagereport-file-link-${file.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`}
                                                            key={file}
                                                            onClick={() =>
                                                                openReport(file)
                                                            }
                                                        >
                                                            {file}
                                                        </FileLinkDiv>
                                                    </FileLinkContainer>
                                                </>
                                            ))}
                                        </UploadedFilesContainer>
                                    </Card>
                                )}
                                <>
                                    {showReportOption ? (
                                        <Card
                                            padding="15px 22px"
                                            margin="10px 0 10px 0"
                                            height="auto"
                                        >
                                            <Header letterSpacing="-0.12px">
                                                {t(
                                                    'orders.reportsAndInvoice.sendUsageReport.reportOptions'
                                                )}
                                            </Header>
                                            <Options>
                                                {sendUsageReportOptions() &&
                                                    sendUsageReportOptions().reportOption.map(
                                                        (rad) => {
                                                            return (
                                                                <RadioButton
                                                                    // noWrap = {'nowrap'}
                                                                    key={
                                                                        rad.label
                                                                    }
                                                                    id={'reportOption'}
                                                                    label={
                                                                        rad.label
                                                                    }
                                                                    fontFamilyStyle={
                                                                        'AvenirNextWorld Regular'
                                                                    }
                                                                    color={
                                                                        '#202124'
                                                                    }
                                                                    isChecked={
                                                                        reportTypeChecked ===
                                                                        rad.value
                                                                    }
                                                                    handleChange={() =>
                                                                        onReportTypeChangeHandler(
                                                                            rad.value
                                                                        )
                                                                    }
                                                                    radioComponentAlignItem={
                                                                        'flex-start'
                                                                    }
                                                                    radioLabelAlignItem={
                                                                        'flex-start'
                                                                    }
                                                                    radioBtnMarginTop={
                                                                        '3.5px'
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )}
                                            </Options>
                                        </Card>
                                    ) : null}

                                    <CollapsableCard
                                        id="orders-sendUsageReport-sendUsageReport-recipients"
                                        title={t(
                                            'orders.reportsAndInvoice.sendUsageReport.Recipients'
                                        )}
                                        onClick={() =>
                                            setIsExpanded({
                                                ...isExpanded,
                                                isRecipients:
                                                    !isExpanded.isRecipients,
                                            })
                                        }
                                        isExpanded={isExpanded.isRecipients}
                                        padding="10px 20px"
                                        collapsableCardClassName={
                                            priceChecked === '' && 'disabled'
                                        }
                                        showAstrisk={
                                            isExpanded.isRecipients
                                                ? true
                                                : false
                                        }
                                    >
                                        {isExpanded.isRecipients && (
                                            <>
                                                <Header letterSpacing="-0.12px">
                                                    {t(
                                                        'orders.reportsAndInvoice.sendUsageReport.Sendto'
                                                    )}
                                                </Header>
                                                <BasicOptionContainer
                                                    mbWidth={'100%'}
                                                >
                                                    {sendUsageReportOptions() &&
                                                        sendUsageReportOptions().email_fax.map(
                                                            (rad) => {
                                                                return (
                                                                    <RadioButton
                                                                        noWrap = {'nowrap'}
                                                                        key={
                                                                            rad.label
                                                                        }
                                                                        id={'sendOption'}
                                                                        label={
                                                                            rad.label
                                                                        }
                                                                        fontFamilyStyle={
                                                                            'AvenirNextWorld Regular'
                                                                        }
                                                                        color={
                                                                            '#202124'
                                                                        }
                                                                        isChecked={
                                                                            sendTypeChecked ===
                                                                            rad.value
                                                                        }
                                                                        handleChange={() =>
                                                                            onSendTypeChangeHandler(
                                                                                rad.value
                                                                            )
                                                                        }
                                                                    />
                                                                );
                                                            }
                                                        )}
                                                </BasicOptionContainer>

                                                {sendTypeChecked ===
                                                    'isEmail' &&
                                                    emailInputBoxes.map(
                                                        (item, index) => (
                                                            <React.Fragment
                                                                key={index}
                                                            >
                                                                <AddRecipientContainer
                                                                    flexDirection={
                                                                        'column'
                                                                    }
                                                                    alignItems="flex-start"
                                                                >
                                                                    <InputWithRecipientContainer>
                                                                        <InputCont
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <Input
                                                                             id={`orders-sendusagereport-email-input-${index}`}
                                                                                placeholder={t(
                                                                                    'orders.reportsAndInvoice.sendUsageReport.emailAddress'
                                                                                )}
                                                                                onChange={(
                                                                                    event
                                                                                ) =>
                                                                                    onChangeEmail(
                                                                                        index,
                                                                                        event
                                                                                            .target
                                                                                            .value
                                                                                    )
                                                                                }
                                                                                value={
                                                                                    item.value ||
                                                                                    ''
                                                                                }
                                                                            />
                                                                        </InputCont>

                                                                        {emailInputBoxes.length -
                                                                            1 ===
                                                                            index && (
                                                                            <Add
                                                                             id="orders-sendusagereport-add-email-recipient-button"
                                                                                onClick={
                                                                                    onAddEmailRecipientHandler
                                                                                }
                                                                            >
                                                                                {t(
                                                                                    'orders.reportsAndInvoice.requestInvoice.addrecipit'
                                                                                )}
                                                                            </Add>
                                                                        )}
                                                                    </InputWithRecipientContainer>
                                                                    {item?.errorMessage && (
                                                                        <ErrorContainer>
                                                                            {
                                                                                item.errorMessage
                                                                            }
                                                                        </ErrorContainer>
                                                                    )}
                                                                </AddRecipientContainer>
                                                            </React.Fragment>
                                                        )
                                                    )}
                                                {sendTypeChecked === 'isFax' &&
                                                    faxInputBoxes.map(
                                                        (item, index) => {
                                                            return (
                                                                <React.Fragment
                                                                    key={index}
                                                                >
                                                                    <AddRecipientContainer
                                                                        flexDirection={
                                                                            'column'
                                                                        }
                                                                        alignItems="flex-start"
                                                                    >
                                                                        <InputWithRecipientContainer>
                                                                            <InputCont
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                <Input
                                                                                 id={`orders-sendusagereport-fax-input-${index}`}
                                                                                    placeholder={t(
                                                                                        'orders.reportsAndInvoice.sendUsageReport.faxNumber'
                                                                                    )}
                                                                                    onChange={(
                                                                                        event
                                                                                    ) =>
                                                                                        onChangeFax(
                                                                                            index,
                                                                                            event
                                                                                                .target
                                                                                                .value
                                                                                        )
                                                                                    }
                                                                                    value={
                                                                                        item?.value
                                                                                            ? getFormattedPhoneNumber(
                                                                                                  item.value,
                                                                                                  true
                                                                                              )
                                                                                            : ''
                                                                                    }
                                                                                    onFocus={() =>
                                                                                        handleKeyboardOpen(
                                                                                            '150px',
                                                                                            'RecipientCard'
                                                                                        )
                                                                                    }
                                                                                    onBlur={() =>
                                                                                        handleKeyboardClose(
                                                                                            '0px'
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </InputCont>

                                                                            {faxInputBoxes.length -
                                                                                1 ===
                                                                                index && (
                                                                                <Add
                                                                                id="orders-sendusagereport-add-fax-recipient-button"
                                                                                    onClick={
                                                                                        onAddFaxRecipientHandler
                                                                                    }
                                                                                >
                                                                                    {t(
                                                                                        'orders.reportsAndInvoice.requestInvoice.addrecipit'
                                                                                    )}
                                                                                </Add>
                                                                            )}
                                                                        </InputWithRecipientContainer>
                                                                        {item?.errorMessage && (
                                                                            <ErrorContainer>
                                                                                {
                                                                                    item.errorMessage
                                                                                }
                                                                            </ErrorContainer>
                                                                        )}
                                                                    </AddRecipientContainer>
                                                                </React.Fragment>
                                                            );
                                                        }
                                                    )}
                                                {userDetails?.emailId &&
                                                    sendTypeChecked ===
                                                        'isEmail' && (
                                                        <CheckBoxContainer>
                                                            <Checkbox
                                                                checked={userEmailIdSelected}
                                                                label={`${t(
                                                                    'orders.reportsAndInvoice.sendUsageReport.sendCopy'
                                                                )} ${
                                                                    userDetails.emailId
                                                                }`}
                                                                onCheckboxSelectionChange={() => {
                                                                    setUserEmailIdSelected(
                                                                        !userEmailIdSelected
                                                                    );
                                                                    const emailInputBox =
                                                                        [
                                                                            ...emailInputBoxes,
                                                                        ];
                                                                    emailInputBox.map(
                                                                        (
                                                                            email
                                                                        ) => {
                                                                            if (
                                                                                email.value ===
                                                                                ''
                                                                            ) {
                                                                                email.errorMessage =
                                                                                    '';
                                                                            }
                                                                            return email;
                                                                        }
                                                                    );
                                                                    setEmailInputBoxes(
                                                                        emailInputBox
                                                                    );
                                                                }}
                                                                id="orders-reportsAndInvoice-sendUsageReport-sendCopy-checkbox"
                                                                margin={'0 16px 0 0'}
                                                                labelStyleObj={{padding: XX_SMALL_TEXT_PX}}
                                                                background={'none'}
                                                                checkboxBorder={'1.5px solid #555555'}
                                                                alignItemDirection={'center'}
                                                                hoverEffect={'false'}
                                                                disableFocusEffect={'true'}
                                                                checkboxWrapperDisplay={'inline-flex'}
                                                            />
                                                        </CheckBoxContainer>
                                                    )}
                                                <ButtonContainer
                                                    height={
                                                        statusCode ===
                                                            '10810' && '3rem'
                                                    }
                                                    borderTop={
                                                        statusCode ===
                                                            '10810' &&
                                                        '1px solid #00000029'
                                                    }
                                                    justifyContent={
                                                        'space-between'
                                                    }
                                                >
                                                    <ReportsFooter
                                                        viewReportHandler={
                                                            viewReportHandler
                                                        }
                                                        onSendUsageReport={
                                                            onSendUsageReport
                                                        }
                                                        loading={loading}
                                                        isMobile
                                                        isSent={
                                                            statusCode ===
                                                            '10810'
                                                        }
                                                        disabled={
                                                            priceChecked !== ''
                                                                ? false
                                                                : true
                                                        }
                                                    ></ReportsFooter>
                                                </ButtonContainer>
                                                <StyledHorizontalRow />
                                            </>
                                        )}
                                    </CollapsableCard>
                                </>

                                {reportHistory && reportHistory.length > 0 && (
                                    <CollapsableCard
                                        id="orders-sendUsageReport-sendUsageReport-reportHistory"
                                        title={t(
                                            'orders.reportsAndInvoice.sendUsageReport.ReportHistory'
                                        )}
                                        onClick={() =>
                                            setIsExpanded({
                                                ...isExpanded,
                                                isHistoryExpanded:
                                                    !isExpanded.isHistoryExpanded,
                                            })
                                        }
                                        isExpanded={
                                            isExpanded.isHistoryExpanded
                                        }
                                        padding="10px 22px"
                                    >
                                        {isExpanded.isHistoryExpanded && (
                                            <ReportHistory
                                                reportHistory={reportHistory}
                                                isEmail={
                                                    sendTypeChecked ===
                                                    'isEmail'
                                                        ? true
                                                        : false
                                                }
                                                discrepancyEntries={
                                                    discrepancyEntries
                                                }
                                            />
                                        )}
                                    </CollapsableCard>
                                )}
                            </div>
                        </DetailBody>
                    </ContentBody>
                    {poImagePreviewLoader && (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="orders-sendUsageReport-sendUsageReport-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            ></Spinner>
                        </Backdrop>
                    )}
                    <FooterContent>
                        <ReportsFooter
                            viewReportHandler={viewReportHandler}
                            onSendUsageReport={onSendUsageReport}
                            loading={loading}
                            isSent={statusCode === '10810'}
                            disabled={priceChecked !== '' ? false : true}
                        ></ReportsFooter>
                    </FooterContent>
                </ModalDialog>
            )}
        </>
    );
};

export default SendUsageReport;
